var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle, _circle2, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScenery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    viewBox: "0 0 64 64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8fa8b8",
    d: "m12 45 15.29-25.18a2 2 0 0 1 3.42 0L46 45z",
    "data-original": "#8fa8b8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#7896aa",
    d: "M30 19.13a1.9 1.9 0 0 0-.71.69L14 45h32L30.71 19.82a1.9 1.9 0 0 0-.71-.69",
    "data-original": "#7896aa"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0fbff",
    d: "M29 26.75 32.83 29 35 26.94l-4.32-7.12a2 2 0 0 0-3.42 0L23 26.94 25.17 29z",
    "data-original": "#f0fbff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#daf5ff",
    d: "M25.17 29 29 26.75 32.83 29 35 26.94l-4.32-7.12a1.9 1.9 0 0 0-.71-.69 1.9 1.9 0 0 0-.71.69l-5.05 8.31z",
    "data-original": "#daf5ff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#8fa8b8",
    d: "M63 40.5 48.71 17a2 2 0 0 0-3.42 0L27 47.09h36z",
    "data-original": "#8fa8b8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#7896aa",
    d: "M48.71 16.87a2 2 0 0 0-.71-.69 2 2 0 0 0-.71.69L29 47h34v-6.59z",
    "data-original": "#7896aa"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0fbff",
    d: "m47 25.43 4.47 2.63L54 25.65l-5.33-8.78a2 2 0 0 0-3.42 0L40 25.65l2.57 2.41z",
    "data-original": "#f0fbff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#daf5ff",
    d: "M48 16.18a2 2 0 0 0-.71.69l-6 10 1.29 1.21L47 25.43l4.47 2.63L54 25.65l-5.33-8.78a2 2 0 0 0-.67-.69",
    "data-original": "#daf5ff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#82d246",
    d: "M15 37a4 4 0 0 0-7.39-2.11A6 6 0 0 0 2 31a5.6 5.6 0 0 0-1 .09V45h19v-3a5 5 0 0 0-5-5",
    "data-original": "#82d246"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#91e957",
    d: "M15 37a4 4 0 0 0-7.39-2.11A6 6 0 0 0 2 31a5.6 5.6 0 0 0-1 .09v2A5.6 5.6 0 0 1 2 33a6 6 0 0 1 5.61 3.89A4 4 0 0 1 15 39a5 5 0 0 1 5 5v-2a5 5 0 0 0-5-5m48 3v23H1V52a110.5 110.5 0 0 0 30.86-5.5A70.14 70.14 0 0 1 63 40",
    "data-original": "#91e957"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#82d246",
    d: "M31.86 48.5A110.5 110.5 0 0 1 1 54v9h62V42a70.14 70.14 0 0 0-31.14 6.5",
    "data-original": "#82d246"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#bef878",
    d: "M58 58H1V45s5-3 17-3c28 0 40 16 40 16",
    "data-original": "#bef878"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#bef878",
    d: "M58 58H1V45s5-3 17-3c28 0 40 16 40 16",
    "data-original": "#bef878"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b5f82",
    d: "M32 12a1 1 0 0 1-.89-.55l-.11-.21A2.22 2.22 0 0 0 29 10a1 1 0 0 1 0-2 4.24 4.24 0 0 1 3 1.24A4.24 4.24 0 0 1 35 8a1 1 0 0 1 0 2 2.22 2.22 0 0 0-2 1.24l-.11.21A1 1 0 0 1 32 12m7-6a1 1 0 0 1-.89-.55L38 5.24A2.22 2.22 0 0 0 36 4a1 1 0 0 1 0-2 4.24 4.24 0 0 1 3 1.24A4.24 4.24 0 0 1 42 2a1 1 0 0 1 0 2 2.22 2.22 0 0 0-2 1.24l-.11.21A1 1 0 0 1 39 6",
    "data-original": "#4b5f82"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "#82d246",
    d: "M23 50c11.38 0 22 4.29 28 13H1v-6.41C7 51.77 14.77 50 23 50",
    "data-original": "#82d246"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#d2ff9f",
    d: "M56.2 58H58S46 42 18 42C6 42 1 45 1 45v2s5-3 17-3c21.81 0 33.91 9.71 38.2 14",
    "data-original": "#d2ff9f"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#91e957",
    d: "M49.45 63H51c-6-8.71-16.62-13-28-13-8.23 0-16 1.77-22 6.59v2C7 53.77 14.77 52 23 52c10.47 0 20.25 3.64 26.45 11",
    "data-original": "#91e957"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#59b22b",
    d: "M12 63h51v-5.33S59 55 44 55c-14 0-27 5-32 8",
    "data-original": "#59b22b"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#4b961f",
    d: "M16 63h47v-3.33S59 57 44 57a72.8 72.8 0 0 0-28 6",
    "data-original": "#4b961f"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#ffbe39",
    d: "M13 8h-2a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2M3 8H1a1 1 0 0 1 0-2h2a1 1 0 0 1 0 2m6.83-2.83a1 1 0 0 1-.71-.29 1 1 0 0 1 0-1.42l1.42-1.41A1 1 0 0 1 12 3.46l-1.46 1.42a1 1 0 0 1-.71.29m-7.07 7.07a1 1 0 0 1-.71-.24 1 1 0 0 1 0-1.41l1.41-1.47a1 1 0 1 1 1.42 1.42L3.46 12a1 1 0 0 1-.7.24M7 4a1 1 0 0 1-1-1V1a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1m0 10a1 1 0 0 1-1-1v-2a1 1 0 0 1 2 0v2a1 1 0 0 1-1 1M4.17 5.17a1 1 0 0 1-.71-.29L2.05 3.46a1 1 0 0 1 1.41-1.41l1.42 1.41a1 1 0 0 1 0 1.42 1 1 0 0 1-.71.29m7.07 7.07a1 1 0 0 1-.7-.29l-1.42-1.41a1 1 0 1 1 1.42-1.42L12 10.54A1 1 0 0 1 12 12a1 1 0 0 1-.76.24",
    "data-original": "#ffbe39"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7,
    r: 5,
    fill: "#ffdc5d",
    "data-original": "#ffdc5d"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 1.5,
    fill: "#ffef98",
    "data-original": "#ffef98"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "#f0fbff",
    d: "M61 1a4 4 0 0 0-3.2 1.62A3 3 0 0 0 53 5a1 1 0 0 0 0 .18A3 3 0 0 0 54 11h9V1.55A4 4 0 0 0 61 1",
    "data-original": "#f0fbff"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#daf5ff",
    d: "M59.8 4.62A3 3 0 0 0 55 7a1 1 0 0 0 0 .18A3 3 0 0 0 53 10a3 3 0 0 0 .14.86A3 3 0 0 0 54 11h9V3a4 4 0 0 0-3.2 1.62",
    "data-original": "#daf5ff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScenery);
export default __webpack_public_path__ + "static/media/scenery.c4cbc72d38ade3aa8a9016f501470167.svg";
export { ForwardRef as ReactComponent };